export default __webpack_public_path__ + "static/media/FAVICON_11.f2f0b226.png";